export class Kardex {
    numKardex:string = '';
    fechaIngreso:string = '';
    recepcion:string = '';
    fechaIngresoLetra:string = '';
    ubicacionFirma:number = 0;
    fechaInstrumento:string = '';
    fechaConclusion:string = '';
    numeroInstrumento:string = '';
    abogadoResponsable:string = '';
    contrato:string = '';
    referencia:string = '';
}

export class KardexResponse {
    kardexs:Kardex[];
    contratantes:any;
    detalleMovimientosRrpp:any;
    inCodigoRespuesta:number;
    total:number;

}